// @ts-strict-ignore
import { Material } from 'three';
import { ArticleVO } from '@article/model/vo/article.vo';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { IArticleTextureParameters } from './i-article-texture-parameters';
import { DefaultArticleTextureParameters } from './default-article-texture-parameters';
import { IArticleTextureParametersGenerator } from './i-article-texture-parameters-generator';
import { IsThreeJsType } from '@3d-scene/common/util/is-threejs-type';

export class DefaultArticleTextureParametersGenerator implements IArticleTextureParametersGenerator {
  public generateParameters(articleContainer: ArticleContainer, material: Material): IArticleTextureParameters {
    if (!articleContainer || !material || !((material as any).hasOwnProperty('map') && IsThreeJsType.texture((material as any)['map']))) {
      return null;
    }
    const article: ArticleVO = articleContainer.article;
    if (!article) {
      return null;
    }
    return new DefaultArticleTextureParameters(material, article);
  }
}
